export default __webpack_public_path__ + "static/image-25-65d6bc786b68897b7c569dac238e2e0a.jpg";